export default "__VITE_ASSET__dVhe40YK__"